import HandleCreatePackage from "./components/HandlCreatePackage";
type CreateUserProps = {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
};
const CreatePackage: React.FC<CreateUserProps> = ({ closeModal }) => {
  return (
    <>
      <HandleCreatePackage closeModal={closeModal} />
    </>
  );
};
export default CreatePackage;
